import * as React from "react";
import { SVGProps } from "react";

const ArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 8.83333L8.83333 0.5M8.83333 0.5H0.5M8.83333 0.5V8.83333"
      stroke="#18B5B7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowUpRight;

